import { render, staticRenderFns } from "./PersonManagePage.vue?vue&type=template&id=44b1c3b1&scoped=true&"
import script from "./PersonManagePage.vue?vue&type=script&lang=js&"
export * from "./PersonManagePage.vue?vue&type=script&lang=js&"
import style0 from "./PersonManagePage.vue?vue&type=style&index=0&id=44b1c3b1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b1c3b1",
  null
  
)

export default component.exports